import { Card, CardContent, Grid } from "@mui/material";
import React from "react";
import {
  TaxTypeSelectComponent,
  TaxNumberComponent,
  IDTypeSelectComponent,
  IDNumberComponent,
  PassportComponent,
  OneColumn,
  MenuItemsForDropDown,
  IDType,
  NameField,
  SurnameField,
  TitleSelectComponent,
  InitialsField,
} from "@soqs/common";
import { useSelector } from "react-redux";
import {
  dropdownopts,
  dropdownsloading,
  isPrepop,
} from "../../features/AppSlice";

import { useFormState } from "react-final-form";

const TaxpayerDetails = () => {
  const dropdownloading = useSelector(dropdownsloading);
  const dropdownoptions = useSelector(dropdownopts);

  const prepop = useSelector(isPrepop);
  const formstate = useFormState();

  return (
    <Grid size={{ xs: 12 }}>
      <Card>
        <CardContent>
          <Grid container columnSpacing={1.5} rowSpacing={0.5}>
            <OneColumn>
              <TitleSelectComponent
                optionsloading={dropdownloading}
                titleOptions={MenuItemsForDropDown("title", dropdownoptions)}
                disabled={prepop?.includes("title")}
              />
            </OneColumn>
            <OneColumn>
              <NameField name="name" disabled={prepop?.includes("name")} />
            </OneColumn>
            <OneColumn>
              <InitialsField
                name="initials"
                label="Initials"
                required={true}
                disabled={prepop?.includes("initials")}
              />
            </OneColumn>
            <OneColumn>
              <SurnameField
                name="surname"
                disabled={prepop?.includes("surname")}
              />
            </OneColumn>
            <OneColumn>
              <IDTypeSelectComponent
                idoptions={MenuItemsForDropDown(
                  "idtype",
                  dropdownoptions,
                  true
                )}
                optionsloading={dropdownloading}
                disabled={prepop?.includes("idtype")}
              />
            </OneColumn>
            <OneColumn>
              {formstate.values?.idtype === IDType.RSA_Id ? (
                <IDNumberComponent
                  autocomplete="idnumber"
                  disabled={prepop?.includes("idnumber")}
                />
              ) : (
                <PassportComponent />
              )}
            </OneColumn>
            <OneColumn>
              <TaxTypeSelectComponent
                optionsloading={dropdownloading}
                taxoptions={MenuItemsForDropDown(
                  "taxtype",
                  dropdownoptions,
                  true
                )}
                disabled={prepop?.includes("taxtype")}
              />
            </OneColumn>
            <OneColumn>
              <TaxNumberComponent disabled={prepop?.includes("taxnumber")} />
            </OneColumn>
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default TaxpayerDetails;
